// extracted by mini-css-extract-plugin
module.exports = {"next":"L_cf","light":"L_s","icon":"L_bJ","left":"L_cc","right":"L_bw"};